import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { GrausParentescoService } from 'src/app/services/graus-parentesco/graus-parentesco.service';
import { GrausParentesco } from 'src/app/core/graus-parentesco';

@Component({
  selector: 'combo-grau-parentesco',
  templateUrl: './combo-grau-parentesco.component.html',
  styleUrls: ['./combo-grau-parentesco.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
                  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboGrauParentescoComponent implements OnInit {

  @ViewChild('comboGrauParentesco', {static: false}) comboGrauParentesco;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;
  @Input() label = 'Grau de Parentesco';

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor(private grausParentescoService: GrausParentescoService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    // Carrega graus de parentesco dinamicamente do serviço
    this.grausParentescoService.getAll().subscribe((graus: GrausParentesco[]) => {
      this.dados = graus;
      this.preencherCombo();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { nome: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
